import { render, staticRenderFns } from "./box_1.vue?vue&type=template&id=2afe333e&scoped=true&"
import script from "./box_1.vue?vue&type=script&lang=js&"
export * from "./box_1.vue?vue&type=script&lang=js&"
import style0 from "./box_1.vue?vue&type=style&index=0&id=2afe333e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe333e",
  null
  
)

export default component.exports